import { decodeToken, isNotDefined } from '@hsp/utilities';

import { TokenInvalidError } from 'types/errors/token';
import { IUser } from 'types/user';

export const translateToken = (token: string): IUser => {
  const decoded = decodeToken(token);

  if (isNotDefined(decoded)) {
    throw new TokenInvalidError();
  }

  const { displayName, email, family_name: familyName, given_name: givenName, sub } = decoded;
  const devOps = process.env.REACT_APP_DEV_OPS?.split(',') ?? [];
  let { role } = decoded;

  if (devOps.includes(email)) {
    role = [...role, 'devops'];
  }

  return {
    displayName,
    email,
    firstName: givenName,
    lastName: familyName,
    role,
    userId: sub,
  };
};
